import isEmpty from 'lodash/fp/isEmpty';

import useGetApi from 'utils/useGetApi';

// TODO: Stop using useGetApi in favor of a simple try/catch in server-side call (Next.js)
export function useRawIngredients() {
  const [{ data: ingredients, error, isLoading }, callApi] = useGetApi(
    '/v1/raw_ingredients/?group_by=initial'
  );

  // Remove a letter list if no ingredient starts with that letter
  const filteredIngredients = ingredients
    ? Object.entries(ingredients).flatMap(([ingredientKey, ingredientValue]) =>
        isEmpty(ingredientValue) ? [] : [[ingredientKey, ingredientValue]]
      )
    : [];

  return { ingredients: filteredIngredients, error, isLoading, fetchRawIngredients: callApi };
}
